export enum IdentityIntegrationStatusLevels {
    Connected = 'connected',
    Disconnected = 'disconnected',
    NoIntegration = 'noIntegration',
    UpdateRequired = 'updateRequired'
}

export const IdentityIntegrationStatusOrder = [
    IdentityIntegrationStatusLevels.Connected, // Authenticated
    IdentityIntegrationStatusLevels.UpdateRequired, // Connection failed
    IdentityIntegrationStatusLevels.Disconnected, // Disconnected
    IdentityIntegrationStatusLevels.NoIntegration // Not integrated
];
